import { render, staticRenderFns } from "./AddonForm.vue?vue&type=template&id=6401cce5&"
import script from "./AddonForm.vue?vue&type=script&lang=js&"
export * from "./AddonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports